import { render, staticRenderFns } from "./login-2.vue?vue&type=template&id=d6c14ab0&scoped=true&"
import script from "./login-2.vue?vue&type=script&lang=js&"
export * from "./login-2.vue?vue&type=script&lang=js&"
import style0 from "./login-2.vue?vue&type=style&index=0&id=d6c14ab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6c14ab0",
  null
  
)

export default component.exports